import { FLOW_TYPE } from 'consts/flows';
import {
	autoOnboard,
	autoSelect,
	companyTranslationKey,
	handleSubmit,
	hasNotFinishedMifid,
	selectItem
} from 'helpers';
import { AppContext } from 'providers/AppContext';
import { useContext, useEffect, useState } from 'react';

export function useOnboard() {
	const ctx = useContext(AppContext);
	const { entityType, fetchRelations, flowType, getRelations, state } = ctx;
	const { context } = state;
	const { kennitala } = context;
	const { children, companies, person } = getRelations();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const prefix = `${flowType}_onboard_${entityType}`;
	const companyKey = companyTranslationKey(flowType, companies);
	const mifidURL = globalThis.location.href.replace(`/${flowType}/`, `/${FLOW_TYPE.MV}/`);
	const unfinishedMifid = hasNotFinishedMifid(ctx.mifidStatus, flowType);
	const isDisabled = FLOW_TYPE.ES_MV === flowType ? children.every(x => x.disabledCard) : !kennitala;

	const redirectToMifid = () => (globalThis.location.href = mifidURL);
	const onSelect = (ssn = '') => selectItem(ssn, ctx);
	const onSubmit = () => handleSubmit(ctx, setIsModalOpen);

	useEffect(() => {
		fetchRelations();
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		autoSelect(ctx, onSelect);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		autoOnboard(ctx);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return {
		...ctx,
		children,
		companies,
		companyKey,
		entityType,
		flowType,
		isDisabled,
		isModalOpen,
		kennitala,
		mifidURL,
		onSelect,
		onSubmit,
		person,
		prefix,
		redirectToMifid,
		unfinishedMifid
	};
}
